const icon = new URL('../../icons/desk.png', import.meta.url).href

export default {
  type: 'desk',
  description: '3D desk',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'desk',
    left: 100,
    top: 100,
    width: 100,
    height: 100,
    depth: 50,
    fillStyle: '#CCAA76',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1
  }
}
